import { useState, useEffect } from "react";
import { Container, Card, Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { validatePassword } from "../utils/passwordValidation.js";

export default function ResetPassword() {
  const navigate = useNavigate();
  const { token } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (!token) {
      setError("Invalid reset link");
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    const password = e.target.password.value;
    const confirmPassword = e.target.confirmPassword.value;

    // Validate password
    const passwordValidation = validatePassword(password);
    if (!passwordValidation.isValid) {
      setError(passwordValidation.message);
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      setLoading(false);
      return;
    }

    try {
      const res = await fetch(`/api/auth/reset-password/${token}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password }),
      });

      const data = await res.json();

      if (res.ok) {
        setSuccess("Password reset successfully! Redirecting to login...");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        setError(data.message || "Failed to reset password");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      style={{ minHeight: "80vh" }}
      className="d-flex justify-content-center align-items-center py-5"
    >
      <Card className="brutal-card" style={{ width: 450, maxWidth: "100%" }}>
        <Card.Body className="p-5">
          <h2 className="brutal-heading text-center mb-4" style={{ fontSize: "36px" }}>
            RESET PASSWORD
          </h2>

          {error && <Alert variant="danger" className="brutal-alert mb-3">{error.toUpperCase()}</Alert>}
          {success && <Alert variant="success" className="brutal-alert mb-3">{success.toUpperCase()}</Alert>}

          {!token ? (
            <Alert variant="danger" className="brutal-alert mb-3">
              INVALID RESET LINK. PLEASE REQUEST A NEW ONE.
            </Alert>
          ) : (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label className="brutal-subheading mb-2">NEW PASSWORD</Form.Label>
                <Form.Control
                  name="password"
                  type="password"
                  placeholder="ENTER NEW PASSWORD (MIN 8 CHARS, 1 SPECIAL CHAR)"
                  className="brutal-form-control"
                  required
                  minLength={8}
                  disabled={loading || !!success}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="brutal-subheading mb-2">CONFIRM NEW PASSWORD</Form.Label>
                <Form.Control
                  name="confirmPassword"
                  type="password"
                  placeholder="CONFIRM NEW PASSWORD"
                  className="brutal-form-control"
                  required
                  minLength={8}
                  disabled={loading || !!success}
                />
              </Form.Group>

              <Button
                type="submit"
                className="brutal-btn brutal-btn-primary w-100 mb-4"
                disabled={loading || !!success}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    RESETTING PASSWORD...
                  </>
                ) : (
                  "RESET PASSWORD"
                )}
              </Button>
            </Form>
          )}

          <div className="text-center">
            <Button
              variant="link"
              className="brutal-link p-0"
              onClick={() => navigate("/login")}
              disabled={loading}
              style={{ textDecoration: "underline", textDecorationThickness: "2px" }}
            >
              BACK TO LOGIN
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}
